// Service-Location combinations for SEO landing pages
// Each combination gets its own dedicated page for maximum SEO coverage

export const services = [
  {
    id: "web-design",
    name: "Web Design",
    title: "Web Design",
    description: "Custom website design services",
    keywords: ["web design", "website design", "custom websites", "responsive design"],
    icon: "Layout"
  },
  {
    id: "seo",
    name: "SEO",
    title: "SEO Services",
    description: "Search engine optimization services",
    keywords: ["SEO", "search engine optimization", "local SEO", "Google ranking"],
    icon: "Search"
  },
  {
    id: "web-development",
    name: "Web Development",
    title: "Web Development",
    description: "Professional web development services",
    keywords: ["web development", "website development", "web apps", "custom development"],
    icon: "Code"
  },
  {
    id: "digital-marketing",
    name: "Digital Marketing",
    title: "Digital Marketing",
    description: "Comprehensive digital marketing services",
    keywords: ["digital marketing", "online marketing", "PPC", "social media marketing"],
    icon: "TrendingUp"
  },
  {
    id: "ecommerce",
    name: "eCommerce",
    title: "eCommerce Solutions",
    description: "Online store and eCommerce development",
    keywords: ["ecommerce", "online store", "shopping cart", "WooCommerce", "Shopify"],
    icon: "ShoppingCart"
  },
  {
    id: "mobile-apps",
    name: "Mobile Apps",
    title: "Mobile App Development",
    description: "iOS and Android app development",
    keywords: ["mobile apps", "iOS development", "Android apps", "app development"],
    icon: "Smartphone"
  },
  {
    id: "ai-development",
    name: "AI Development",
    title: "AI Web Development",
    description: "AI-powered web solutions",
    keywords: ["AI development", "artificial intelligence", "machine learning", "chatbots"],
    icon: "Bot"
  },
  {
    id: "local-seo",
    name: "Local SEO",
    title: "Local SEO Services",
    description: "Local search optimization for businesses",
    keywords: ["local SEO", "Google My Business", "local search", "map rankings"],
    icon: "MapPin"
  }
];

export const locations = [
  { city: "Dallas", slug: "dallas", county: "Dallas County" },
  { city: "Fort Worth", slug: "fort-worth", county: "Tarrant County" },
  { city: "Arlington", slug: "arlington", county: "Tarrant County" },
  { city: "Plano", slug: "plano", county: "Collin County" },
  { city: "Frisco", slug: "frisco", county: "Collin County" },
  { city: "McKinney", slug: "mckinney", county: "Collin County" },
  { city: "Irving", slug: "irving", county: "Dallas County" },
  { city: "Denton", slug: "denton", county: "Denton County" },
  { city: "Carrollton", slug: "carrollton", county: "Dallas County" },
  { city: "Richardson", slug: "richardson", county: "Dallas County" },
  { city: "Garland", slug: "garland", county: "Dallas County" },
  { city: "Grand Prairie", slug: "grand-prairie", county: "Dallas County" },
  { city: "Mesquite", slug: "mesquite", county: "Dallas County" },
  { city: "Lewisville", slug: "lewisville", county: "Denton County" },
  { city: "Flower Mound", slug: "flower-mound", county: "Denton County" },
  { city: "Allen", slug: "allen", county: "Collin County" },
  { city: "Cedar Hill", slug: "cedar-hill", county: "Dallas County" },
  { city: "Euless", slug: "euless", county: "Tarrant County" },
  { city: "Bedford", slug: "bedford", county: "Tarrant County" },
  { city: "Grapevine", slug: "grapevine", county: "Tarrant County" },
  { city: "Southlake", slug: "southlake", county: "Tarrant County" },
  { city: "Coppell", slug: "coppell", county: "Dallas County" },
  { city: "Rowlett", slug: "rowlett", county: "Dallas County" },
  { city: "Wylie", slug: "wylie", county: "Collin County" },
  { city: "The Colony", slug: "the-colony", county: "Denton County" },
  { city: "Little Elm", slug: "little-elm", county: "Denton County" },
  { city: "Prosper", slug: "prosper", county: "Collin County" },
  { city: "Rockwall", slug: "rockwall", county: "Rockwall County" },
  { city: "Mansfield", slug: "mansfield", county: "Tarrant County" },
  { city: "Keller", slug: "keller", county: "Tarrant County" }
];

// Generate all service-location combinations
export const serviceLocationCombinations = [];

services.forEach(service => {
  locations.forEach(location => {
    serviceLocationCombinations.push({
      service: service,
      location: location,
      slug: `${location.slug}-${service.id}`,
      title: `${location.city} ${service.title}`,
      fullTitle: `${service.title} in ${location.city}, TX`,
      metaTitle: `${location.city} ${service.name} | Professional ${service.title} Services`,
      metaDescription: `Expert ${service.name.toLowerCase()} services in ${location.city}, Texas. Get custom ${service.description.toLowerCase()} from Web-TechServices. Free consultation!`,
      keywords: [
        `${location.city.toLowerCase()} ${service.name.toLowerCase()}`,
        `${service.name.toLowerCase()} ${location.city.toLowerCase()}`,
        `${service.name.toLowerCase()} services ${location.city.toLowerCase()}`,
        `${location.city.toLowerCase()} ${service.name.toLowerCase()} company`,
        `best ${service.name.toLowerCase()} ${location.city.toLowerCase()}`,
        ...service.keywords.map(k => `${k} ${location.city.toLowerCase()}`),
        `${location.county.toLowerCase()} ${service.name.toLowerCase()}`
      ]
    });
  });
});

// Get service by ID
export const getServiceById = (serviceId) => {
  return services.find(s => s.id === serviceId);
};

// Get location by slug
export const getLocationBySlug = (slug) => {
  return locations.find(l => l.slug === slug);
};

// Get combination by slug
export const getCombinationBySlug = (slug) => {
  return serviceLocationCombinations.find(c => c.slug === slug);
};

// Get all combinations for a service
export const getCombinationsForService = (serviceId) => {
  return serviceLocationCombinations.filter(c => c.service.id === serviceId);
};

// Get all combinations for a location
export const getCombinationsForLocation = (locationSlug) => {
  return serviceLocationCombinations.filter(c => c.location.slug === locationSlug);
};

// Featured service-location pairs for homepage/footer
export const featuredCombinations = [
  "dallas-web-design",
  "fort-worth-seo",
  "arlington-web-development",
  "plano-digital-marketing",
  "frisco-web-design",
  "mckinney-seo",
  "irving-web-development",
  "denton-web-design",
  "carrollton-seo",
  "richardson-web-development",
  "garland-digital-marketing",
  "grand-prairie-web-design",
  "mesquite-seo",
  "lewisville-web-design",
  "flower-mound-seo",
  "dallas-ai-development",
  "dallas-ecommerce",
  "fort-worth-local-seo"
];

export default serviceLocationCombinations;
